import PropTypes from "prop-types";
import { isNil } from "ramda";
import { styled } from "@mui/material/styles";

export const StyledButton = styled("button", {
  shouldForwardProp: (prop) => prop !== "clickable" && prop !== "relation",
})(({ theme, clickable, relation }) => ({
  minHeight: 22,
  maxWidth: 56,
  minWidth: 46,
  padding: "6px 10px",
  fontSize: theme.typography.pxToRem(10),
  whiteSpace: "no-wrap",
  textAlign: "center",
  borderRadius: 86,
  border: "none",
  background: theme.palette.relatives[relation]?.background,
  "& > span": {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  [theme.breakpoints.up("mobile")]: {
    minHeight: 25,
    minWidth: 59,
    maxWidth: 86,
    padding: "7px 12px",
    fontSize: theme.typography.pxToRem(12),
  },
  ...(clickable && {
    cursor: "pointer",
  }),
}));

const PersonLabel = ({ label = "Name", relation = null, onClick = null, clickable = false }) => {
  return (
    <StyledButton
      type="button"
      onClick={onClick}
      disabled={!clickable}
      clickable={clickable && !isNil(onClick)}
      relation={relation}
    >
      <span>{label}</span>
    </StyledButton>
  );
};

PersonLabel.propTypes = {
  label: PropTypes.string,
  relation: PropTypes.string,
  onClick: PropTypes.func,
  clickable: PropTypes.bool,
};

export default PersonLabel;
